<template>
  <div class="mpp-project">
    <MileStonesLane :name="project.name" :hasLine="false" :path="{ name: 'ProjectTaktPlan', params: { project_id: project.id } }">
    <MileStone v-for="milestone in milestones" :key="`milestone${milestone.id}`" :token="milestone.token" 
        :status="milestone.status" :large="true" :type="milestone.date ? 'project' : 'train'"
        :style="`cursor: default; left: calc((var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom)) + (var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom)) + (var(--workpackage_width) + 8px) +  (${multiproject_calendar.lookup[milestone.date ? milestone.date : milestone.cl_date]} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom)));`" />
    </MileStonesLane>
    <MPTrain v-for="(train, train_index) in getUObjects({ type: 'trains', ids: project.trains })" :key="`train${train.id}`"
      :project="project" :train="train" :train_index="train_index" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import MPTrain from '@/views/MultiProject/MPTrain.wrapper.vue';
import MileStonesLane from '@/components/ProjectTaktPlan/MileStonesLane.component.vue'
import MileStone from '@/components/ProjectTaktPlan/MileStone.component.vue'

export default {
  props: ['project'],
  components: {
    MPTrain,
    MileStonesLane,
    MileStone
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
    ]),
    ...mapState('MultiProject', [
      'multiproject_calendar'
    ]),
    milestones(){
      let ms = [];
      this.getUObjects({ type: 'milestones', ids: this.project.milestones }).forEach(milestone => {
        // remove %H:%i:%s UTC from milestone date
        if (milestone.date == null) {
          ms.push(milestone);
        }
      });
      return ms
    }
  },
}
</script>
<style>
.mpp-project {
  padding-bottom: 3px;
  margin-bottom: 3px;
  border-bottom: 0.5px solid var(--v-secondary-base);
}
</style>
